import logo from './logo.svg';
import './App.css';
import Greeting from './components/Greeting';

function App() {
	return (
		<div className="App">
			<Greeting />
		</div>
	);
}

export default App;
